import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Auditoría',
    desc: 'Detectas las fugas de sueño en tu entorno actual (luz, temperatura y químicos).'
  }, {
    num: '02',
    title: 'Reconfiguración',
    desc: 'Aplicas los micro-ajustes térmicos y lumínicos que activan tu biología natural.'
  }, {
    num: '03',
    title: 'Consolidación',
    desc: 'Implementas el protocolo anti-pánico para asegurar que, si despiertas, vuelvas a dormir de inmediato.'
  }];
  return <section className="py-10 px-4 md:px-8 bg-[#0f1628]/40" data-id="element-80">
      <div className="max-w-5xl mx-auto" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-82">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-83">Cómo Funciona</h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-84">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-gradient-to-r from-cyan-500/0 via-cyan-500/30 to-cyan-500/0 z-0" data-id="element-85" />

          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: i * 0.2
        }} viewport={{
          once: true
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-86">
              <div className="w-24 h-24 rounded-full bg-[#0f1628] border-2 border-cyan-500/30 flex items-center justify-center mb-6 shadow-lg shadow-cyan-500/10" data-id="element-87">
                <span className="text-3xl font-heading font-bold text-white" data-id="element-88">
                  {step.num}
                </span>
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-89">
                {step.title}
              </h3>
              <p className="text-[#b8c4d6]" data-id="element-90">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}